import { render, staticRenderFns } from "./global-all-user-message.html?vue&type=template&id=552ca2a3&scoped=true&external"
import script from "./global-all-user-message.js?vue&type=script&lang=js&external"
export * from "./global-all-user-message.js?vue&type=script&lang=js&external"
import style0 from "./global-all-user-message.scss?vue&type=style&index=0&id=552ca2a3&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ca2a3",
  null
  
)

export default component.exports